import { Link } from "react-router-dom";

import genericUserImage from '../assets/user-icon.png';
import lebenRaffleIcon from '../assets/logo.png';
import { useEffect, useState } from "react";
import { API } from "../APICalls";

export default function Sidebar(){

    const[myUser, setMyUser] = useState({Name: '', Surname: ''});


    useEffect(() => {

        API.GetUser().then((response) => {
            if(response.ok){
                response.json().then((data) => {
                    setMyUser(data);
                });
            }
            else{
                alert("Token is not valid");
            }
        })
        .catch(() =>
        {
            alert("Cannot connect to LebenRaffle API");
        });
    }, []);

    return(

        <aside className="main-sidebar sidebar-dark-primary elevation-4">
            <Link to="/" className="brand-link">
                <img src={lebenRaffleIcon} alt="AdminLTE Logo" className="brand-image img-circle elevation-3" style={{opacity: .8}} />
                <span className="brand-text font-weight-light">Leben<strong>Raffle</strong></span>
            </Link>

            <div className="sidebar">
            <div className="user-panel mt-3 pb-3 mb-3 d-flex">
                <div className="image">
                <img src={genericUserImage} className="img-circle elevation-2" alt="User Image" />
                </div>
                <div className="info">
                <a href="#" className="d-block">{myUser.Name} {myUser.Surname}</a>
                </div>
                
            </div>

            <nav className="mt-2">
                <ul className="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
                    <li className="nav-item">
                        <Link to="/raffles" className="nav-link">
                            <i className="nav-icon fas fa-list"></i>
                            <p>
                                Sorteos
                            </p>
                        </Link>
                    </li>
                    <li className="nav-item">
                        <Link to="/add-raffle" className="nav-link">
                            <i className="nav-icon fas fa-plus"></i>
                            <p>
                                Crear Sorteo
                            </p>
                        </Link>
                    </li>
                    <li>
                        <hr style={{borderColor: "#4f5962"}} />
                    </li>
                    <li className="nav-item">
                        <Link to="/users" className="nav-link">
                            <i className="nav-icon fas fa-users"></i>
                            <p>
                                Usuarios
                            </p>
                        </Link>
                    </li>
                    <li className="nav-item">
                        <Link to="/add-user" className="nav-link">
                            <i className="nav-icon fas fa-user-plus"></i>
                            <p>
                                Crear Usuario
                            </p>
                        </Link>
                    </li>
                </ul>
            </nav>
            </div>
        </aside>

    );

}